export default __webpack_public_path__ + "static/media/banner-driver.bbb75d19.png";